import useGlobalStore from "src/stores/useGlobalStore";

const hasLoggedInCredentials = async () => {
	const { loggedIn } = useGlobalStore.getState();
	return loggedIn;
};

export default hasLoggedInCredentials;
